import Typography from "components/typography";
import React from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa6";
import styled from "styled-components";
import { Colors } from "utils/colors";

const WeeklyReport = () => {
  const type = "increase";
  return (
    <Container>
      <Typography size="2xl" weight="semibold" mb="0.8">
        Weekly Report
      </Typography>
      <Typography color={Colors.grey500}>Total Streams</Typography>
      <Typography size="4.8rem" weight="semibold" mb="1.6">
        {Number("371612").toLocaleString()}
      </Typography>
      <PercentContainer type={type}>
        <Typography size="xl" color="inherit" mr="0.5">
          {type === "increase" ? "+" : "-"}5.22%
        </Typography>
        {type === "increase" ? (
          <FaCaretUp size={14} />
        ) : (
          <FaCaretDown size={14} />
        )}
      </PercentContainer>
    </Container>
  );
};

export default WeeklyReport;

const Container = styled.div`
  height: 100%;
  width: 100%;
  border-left: 0.5px solid ${Colors.grey600};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media only screen and (max-width: 769px) {
    padding: 2.4rem;
    border-top: 0.5px solid ${Colors.grey600};
    border-left: none;
  }
`;

const PercentContainer = styled.div<{ type: string }>`
  display: flex;
  align-items: center;
  color: ${(props) =>
    props.type === "increase" ? Colors.success : Colors.danger};
`;
